import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DnsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dns"}/>
}
